 
// src/redux/reducers/salaryTypeReducer.js
import {
    FETCH_SALARYTYPE_FAILURE,
    FETCH_SALARYTYPE_REQUEST,
    FETCH_SALARYTYPE_SUCCESS, 
    SET_SELECTED_SALARYTYPE 
  } from '../types';
  
  const initialState = {
    loading: false,
    salaryTypeList: [],
    selectedSalaryTypeId: null, 
    error: null,
  };
  
  
  const salaryTypeReducer = (state = initialState, action) => {
    switch (action.type) {
      case FETCH_SALARYTYPE_REQUEST:
        return { ...state, loading: true };
      case FETCH_SALARYTYPE_SUCCESS:
        return { ...state, loading: false, salaryTypeList: action.payload };
      case FETCH_SALARYTYPE_FAILURE:
        return { ...state, loading: false, error: action.payload };
      case SET_SELECTED_SALARYTYPE:
        return { ...state, selectedSalaryTypeId: action.payload };
      default:
        return state;
    }
  };
  
  export default salaryTypeReducer;
  